//
// smooth-scroll.js
// Theme module
//

(function() {
  //
  // Variables
  //

  const toggle = '[data-toggle="smooth-scroll"]';

  //
  // Functions
  //

  function init(toggle) {
    const options = {
      header: '.navbar.fixed-top',
      offset(anchor, toggle) {
        return toggle.dataset.offset ? toggle.dataset.offset : 24;
      },
    };

    // Init
    new SmoothScroll(toggle, options);
  }

  //
  // Events
  //

  if (typeof SmoothScroll !== 'undefined' && toggle) {
    init(toggle);
  }
})();
